import { useState } from 'react';
import useGetHook from '../../customHooks/useGetHook';
import Button from '../Reusable/Button';
//@ts-ignore
//@ts-ignore
import { tw } from '@careinfo/tailwind';
//@ts-ignore
import { usePDFPrintHook, useDownload } from '@careinfo/layout';
import moment from 'moment';
import APIS from '../../constant/EndPoint';
import { responsiveClassName } from '../../utils/classNames';
import Modal from '../Reusable/Modal';
import MakePayment from './MakePayment';
const CargoInvoicePreview = (props: any) => {
  const { order, id } = props;
  const [makePayment, setMakePayment] = useState(false);

  const { data: clientData } = useGetHook({
    queryKey: [`client-setting`],
    url: `${APIS.CLIENT_SETTING}`,
    params: {},
  });

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handlePrint = async () => {
    const url = `${APIS.INVOICE}${id}/print-pdf-invoice/?type=packaging-invoice`;
    let formData = {};
    try {
      const res = await downloadPrint(url);
    } catch (err) {
      console.log(err);
    }
  };

  const handleShipmentPrint = async () => {
    const url = `${APIS.INVOICE}${id}/print-pdf-invoice/`;
    let formData = {};
    try {
      const res = await downloadPrint(url);
    } catch (err) {
      console.log(err);
    }
  };
  const { download } = useDownload();

  const handleDownloadExcel = async () => {
    try {
      await download(
        `${APIS.INVOICE}${id}/download-order/`,
        `${order?.user?.full_name}-statement-${moment().format(
          'MMMM-Do-YYYY-h-mm-ss'
        )}.xlsx`
      );
    } catch (err) {
      console.error(err);
    }
  };

  const chargeKeys = Array.from(
    new Set(
      order?.orders?.flatMap(
        (item) => item.charges?.flatMap((c) => Object.keys(c)) ?? []
      )
    )
  );

  return (
    <>
      <div className={tw`max-w-[85rem] px-4 sm:px-6 mx-auto`}>
        <div className={tw`sm:w-11/12 lg:w-3/4 mx-auto`}>
          <div className={tw`mb-6 flex justify-end gap-x-3 `}>
            <div className={tw`w-1/2 justify-end flex gap-x-8`}>
              <Button
                label='Print'
                type='button'
                onClick={handleShipmentPrint}
                isLoading={isPrintLoading}
              />
              <Button
                label='Download'
                type='button'
                onClick={handleDownloadExcel}
              />
            </div>
          </div>
          {/* Card */}
          <div
            className={tw`flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl `}
          >
            {/* Grid */}
            <div className={tw`flex justify-between`}>
              <div>
                <img
                  className={tw`h-[4rem] object-contain`}
                  src={clientData?.logo}
                  alt='logo'
                />
              </div>
              {/* Col */}

              <div className={tw`text-right`}>
                <h2
                  className={tw`text-2xl md:text-3xl font-semibold text-gray-500 `}
                >
                  Statement #
                </h2>
                <span className={tw`mt-1 block text-gray-500`}>
                  {order?.invoice_id}
                </span>
                <address className={tw`mt-1 not-italic text-gray-500 `}>
                  {clientData?.address ?? 'N/A'}
                  <br />
                </address>
              </div>
              {/* Col */}
            </div>
            {/* End Grid */}

            {/* Grid */}
            <div
              className={responsiveClassName(
                `mt-8 text-sm grid grid-cols-1 gap-1`,
                `mt-8 text-sm grid grid-cols-2  gap-3`
              )}
            >
              <div>
                <h3 className={tw` font-semibold text-gray-500 `}>Bill to:</h3>
                <h3 className={tw` font-semibold text-gray-500  capitalize`}>
                  {order?.user?.full_name ?? 'N/A'}
                </h3>
                <p className={tw`font-semibold text-gray-500   `}>
                  PAN/VAT :{order?.merchant_pan}
                </p>
                <address className={tw`mt-2 not-italic text-gray-500`}>
                  {order?.user?.mobile_number ?? 'N/A'},<br />
                  {order?.user?.email ?? 'N/A'},<br />
                  Kathmandu, Nepal
                  <br />
                </address>
              </div>
              {/* Col */}

              <div
                className={responsiveClassName(
                  `text-left space-y-2`,
                  `text-right space-y-2`
                )}
              >
                {/* Grid */}
                <div
                  className={responsiveClassName(
                    `grid grid-cols-1 gap-1`,
                    'grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2'
                  )}
                >
                  <dl className={tw`grid grid-cols-5 gap-x-3 `}>
                    <dt
                      className={tw`col-span-3 text-sm font-semibold text-gray-500  `}
                    >
                      Statement date:
                    </dt>
                    <dd className={tw`col-span-2  text-sm text-gray-500`}>
                      {moment(order?.created).format('YYYY/MM/DD ')}
                    </dd>
                  </dl>
                  <dl className={tw`grid sm:grid-cols-5  text-sm  gap-x-3`}>
                  <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                    Payment Method:
                  </dt>
                  <dd
                    className={tw`col-span-2 text-xs  text-gray-500 uppercase mt-1`}
                  >
                    {Array.isArray(order?.payment_method) ? (
                      <div>
                        {order.payment_method.map((p: any, i: number) => (
                          <div key={i}>
                            {p.payment_method} (Rs.{p.amount})
                          </div>
                        ))}
                      </div>
                    ) : typeof order?.payment_method === "object" &&
                      order?.payment_method !== null ? (
                      <span>
                        {order.payment_method.payment_method} (Rs.
                        {order.payment_method.amount})
                      </span>
                    ) : (
                      <span>{order?.payment_method ?? "N/A"}</span>
                    )}
                  </dd>
                </dl>
                  <dl className={tw`grid grid-cols-5  text-sm gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Payment date:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      {order?.settlement_date
                        ? moment(order?.settlement_date).format('YYYY/MM/DD')
                        : 'N/A'}
                    </dd>
                  </dl>
                  <dl className={tw`grid  text-sm  grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Payment Status:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500 uppercase`}>
                      {order?.status}
                    </dd>
                  </dl>
                  {order?.date_range && (
                    <dl className={tw`grid  text-sm  sm:grid-cols-5 gap-x-3`}>
                      <dt
                        className={tw`col-span-3 font-semibold text-gray-500 `}
                      >
                        Date Range:
                      </dt>

                      <dd className={tw`col-span-2 text-gray-500 uppercase`}>
                        {order?.date_range?.lower},{order?.date_range?.upper}
                      </dd>
                    </dl>
                  )}
                </div>
                {/* End Grid */}
              </div>
              {/* Col */}
            </div>
            <div className={tw`overflow-x-auto w-full`}>
              <table
                className={tw`mt-6 w-full border border-gray-400 rounded-lg text-sm`}
              >
                <thead>
                  <tr className={tw`text-center border-b border-gray-400 `}>
                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      SN
                    </th>
                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      HAWB No.
                    </th>
                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      Date
                    </th>
                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      FORWARDING NO.
                    </th>
                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      Sender
                    </th>

                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      RECEIVER
                    </th>

                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      Country
                    </th>

                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      Pieces
                    </th>
                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      Weight
                    </th>
                    {chargeKeys.map((key: any) => (
                      <th
                        key={key}
                        className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                      >
                        {key}
                      </th>
                    ))}
                    <th
                      className={tw`border border-gray-300 px-2 py-1 text-xs font-medium text-gray-500 uppercase`}
                    >
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {order?.orders?.map((item: any, index: number) => (
                    <tr key={index} className={tw`text-center text-sm`}>
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        <p className={tw`font-medium text-gray-500 `}>
                          {index + 1}
                        </p>
                      </td>

                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        <p className={tw` text-sm text-gray-500 `}>
                          {item?.tracking_number}
                        </p>
                      </td>
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        <p
                          className={tw`text-sm text-gray-500 whitespace-nowrap `}
                        >
                          {moment(item?.created).format('YY-MM-DD HH:mm:ss')}
                        </p>
                      </td>
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        <p className={tw` font-medium text-gray-500 `}>
                          {item?.forwarding_no}
                        </p>
                      </td>
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        <p
                          className={tw`font-medium text-gray-500 whitespace-nowrap  flex flex-col`}
                        >
                          {item?.sender.full_name}

                          {/* <p className={tw`font-sm`}>
                            {item?.receiver.primary_contact}
                          </p> */}
                          {/* <p className={tw`font-sm `}>
                            {item?.receiver.address_1}
                          </p> */}
                        </p>
                      </td>
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        <p
                          className={tw`font-medium text-gray-500  whitespace-nowrap flex flex-col`}
                        >
                          {item?.receiver.full_name}

                          {/* <p className={tw`font-sm`}>
                            {item?.receiver.primary_contact}
                          </p> */}
                          {/* <p className={tw`font-sm `}>
                            {item?.receiver.address_1}
                          </p> */}
                        </p>
                      </td>
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        {item?.receiver?.country}
                      </td>

                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        {item?.total_piece ?? 0.0}
                      </td>
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        {item?.charge_wt ?? 0.0}
                      </td>

                      {chargeKeys.map((key: any) => {
                        const totalCharge = item.charges?.reduce(
                          (sum, obj) => sum + (obj[key] || 0),
                          0
                        );
                        return (
                          <td
                            key={key}
                            className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                          >
                            Rs.{totalCharge ?? 0}
                          </td>
                        );
                      })}
                      <td
                        className={tw`border border-gray-300 px-2 py-1 text-gray-500`}
                      >
                        <p className={tw`text-gray-500  `}>
                          Rs.{item?.total_amount ?? 0.0}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className={tw`mt-8 flex sm:justify-end`}>
              <div className={tw`w-full max-w-2xl sm:text-right space-y-2`}>
                {/* Grid */}
                <div className={tw`grid text-sm grid-cols-1 gap-3 `}>
                  <dl className={tw`grid grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Tax:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      Rs. {order?.tax}
                    </dd>
                  </dl>
                  <dl className={tw`grid grid-cols-5 gap-x-3`}>
                    <dt className={tw`col-span-3 font-semibold text-gray-500 `}>
                      Payable Amount:
                    </dt>
                    <dd className={tw`col-span-2 text-gray-500`}>
                      Rs. {order?.invoice_amount}
                    </dd>
                  </dl>
                </div>
                {/* End Grid */}
              </div>
            </div>
            {/* End Flex */}
            <div className={tw`mt-6 sm:mt-12`}>
              <h4 className={tw`text-lg font-semibold text-gray-500 `}>
                Thank you!
              </h4>
              <p className={tw`text-gray-500`}>
                If you have any questions concerning this statement, use the
                following contact information:
              </p>
              <div className={tw`mt-2`}>
                <p className={tw`block text-sm font-medium text-gray-500 `}>
                  {clientData?.email}
                </p>
              </div>
            </div>

            <p className={tw`mt-5 text-sm text-gray-500 mx-auto`}>
              © {new Date().getFullYear()} {clientData?.business_name}.
            </p>
          </div>
          {/* End Card */}
        </div>
      </div>
      <Modal
        isOpen={makePayment}
        setIsOpen={setMakePayment}
        title={'Make Payment'}
        children={
          <>
            <MakePayment setMakePayment={setMakePayment} />
          </>
        }
      />
    </>
  );
};

export default CargoInvoicePreview;
